<template>
  <v-container fluid grid-list-xl>
    <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
    <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
    <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
    <!-- ========================================================================================= -->
    <div v-responsive.lg.xl>
      <div>
        <!--PARITE DES ASSURANCES-->
        <div style="background: rgba(153,153,153,0.39);height:auto">
          <div class="justify-content-center column pt-5">
            <div class="justify-content-center row">
              <h1 class="justify-content-center row titre_for_desktop">{{ $t('home_page.nos_assurances[0]') }}</h1>
            </div>
            <div class="justify-content-center row">
              <v-toolbar class="justify-content-center row underline_bar"></v-toolbar>
            </div>
          </div>

          <div>
            <section style="margin-top:15%!important">
              <div class="grid-flex">
                <div class="col col-image"></div>
                <div class="col col-text">
                  <div class="Aligner-item">
                    <div class="column" style="margin-top: -40%;margin-left:-30%">
                      <div style="display: flex;">
                        <div class="radio-inputs">
                          <label class="radio">
                            <input @change="switchDevis" v-model="choiceType" type="radio" name="radio" value="person"
                                   checked="">
                            <span class="name" style="margin-top: 4px;">{{ $t('home_page.person_devis_label') }}</span>
                          </label>
                          <label class="radio">
                            <input @change="switchDevis" v-model="choiceType" type="radio" name="radio" value="moral">
                            <span class="name" style="margin-top: 4px;">{{ $t('home_page.moral_devis_label') }}</span>
                          </label>
                        </div>

                      </div>
                      <div v-if="person" class="mt-3" style="display: flex">
                        <div class="card" @click="toDevisAuto()">
                          <div class="img-bx">
                            <img   src="../../assets/img/icones/menu/cars_quote.png" alt="devis auto"/>
                          </div>
                          <div class="content">
                            <div class="detail mr-2">
                              <h2>{{ $t('home_page.nos_assurances[1]') }}</h2>
                            </div>
                          </div>
                        </div>

                        <div class="card" @click="toDevisHabitation()">
                          <div class="img-bx">
                            <img   src="../../assets/img/icones/menu/house_quote.png" alt="devis habitation"/>
                          </div>
                          <div class="content">
                            <div class="detail">
                              <h2>{{ $t('home_page.nos_assurances[2]') }}</h2>
                            </div>
                          </div>
                        </div>

                        <div class="card" @click="toDevisVoyage()">
                          <div class="img-bx">
                            <img   src="../../assets/img/icones/menu/travel_quote.png" alt="devis voyage"/>
                          </div>
                          <div class="content">
                            <div class="detail">
                              <h2>{{ $t('home_page.nos_assurances[3]') }}</h2>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div v-if="person" class="mt-3" style="display: flex">
                        <div class="card" @click="toDevisSante()">
                          <div class="img-bx">
                            <img   src="../../assets/img/icones/menu/health_quote.png" alt="devis santé"/>
                          </div>
                          <div class="content">
                            <div class="detail">
                              <h2>{{ $t('home_page.nos_assurances[4]') }}</h2>
                            </div>
                          </div>
                        </div>

                        <div class="card" @click="toDevisVie()">
                          <div class="img-bx">
                            <img   src="../../assets/img/icones/menu/life_quote.png" alt="devis vie"/>
                          </div>
                          <div class="content">
                            <div class="detail">
                              <h2>{{ $t('home_page.nos_assurances[5]') }}</h2>
                            </div>
                          </div>
                        </div>

                        <div class="card" @click="toDevisAssurPlus()">
                          <div class="img-bx">
                            <img   src="../../assets/img/icones/menu/add_quote.png" alt="devis plus"/>
                          </div>
                          <div class="content">
                            <div class="detail">
                              <h2>{{ $t('home_page.nos_assurances[6]') }}</h2>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div v-if="moral" class="mt-3" style="display: flex">
                        <div class="card" @click="toIndividuAccident()" style="cursor:pointer">
                          <div class="img-bx">
                            <img   src="../../assets/img/home/new_home/individual_accident_button.png" alt="devis individuel accident"/>
                          </div>
                          <div class="content">
                            <div class="detail mr-2">
                              <h2>{{ $t('home_page.nos_assurances[12]') }}</h2>
                            </div>
                          </div>
                        </div>

                        <div class="card" @click="toDevisMrp()" style="cursor:pointer">
                          <div class="img-bx">
                            <img   src="../../assets/img/icones/menu/mrp_quote.png" alt="devis mrp"/>
                          </div>
                          <div class="content">
                            <div class="detail" style="margin-bottom:-18px!important">
                              <h2>{{ $t('home_page.nos_assurances[7]') }} {{ $t('home_page.nos_assurances[8]') }} </h2>
                            </div>
                          </div>
                        </div>

                        <div class="card" @click="toDevisTrc()" style="cursor:pointer">
                          <div class="img-bx">
                            <img   src="../../assets/img/icones/menu/trc_quote.png" alt="devis trc"/>
                          </div>
                          <div class="content">
                            <div class="detail" style="margin-bottom:-18px!important">
                              <h2>{{ $t('home_page.nos_assurances[9]') }}</h2>
                            </div>
                          </div>
                        </div>
                      </div>
  
                      <div v-if="moral" class="mt-3" style="display: flex;">
                        <div class="card" @click="toDevisAssurcare()" style="cursor:pointer">
                          <div class="img-bx">
                            <img   src="../../assets/img/icones/menu/health_quote.png" alt="devis assurcare"/>
                          </div>
                          <div class="content">
                            <div class="detail">
                              <h2>{{ $t('home_page.nos_assurances[4]') }}</h2>
                            </div>
                          </div>
                        </div>

                        <div class="card" @click="toCaution()" style="cursor:pointer">
                          <div class="img-bx">
                            <img   src="../../assets/img/home/new_home/caution_button.png" alt="devis caution"/>
                          </div>
                          <div class="content">
                            <div class="detail">
                              <h2>{{ $t('home_page.nos_assurances[10]') }}</h2>
                            </div>
                          </div>
                        </div>

                        <div class="card" @click="toDevisFlotte()" style="cursor:pointer!important">
                          <div class="img-bx">
                            <img   src="../../assets/img/icones/menu/flotte_quote.png" alt="devis flotte"/>
                          </div>
                          <div class="content">
                            <div class="detail">
                              <h2>{{ $t('home_page.nos_assurances[11]') }}</h2>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>

    <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE      =============== -->
    <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
    <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
    <!-- ========================================================================================= -->
    <div v-responsive.sm.xs>
      <div>
        <!--PARITE DES ASSURANCES-->
        <div style="background: rgba(153,153,153,0.39)">
          <div class="justify-content-center column pt-5">
            <div class="justify-content-center row">
              <h1 class="justify-content-center row titre_for_desktop" style="font-size: 20px">
                {{ $t('home_page.nos_assurances[0]') }}</h1>
            </div>
            <div class="justify-content-center row">
              <v-toolbar class="justify-content-center row underline_bar"></v-toolbar>
            </div>
          </div>

          <div style="display: flex;" class="mb-5 mt-5">
            <div class="radio-inputs-mobile ml-5 mr-5">
              <label class="radio">
                <input @change="switchDevis" v-model="choiceType" type="radio" name="radio_mobile" value="person">
                <span class="name" style="margin-top: 4px;">{{ $t('home_page.person_devis_label') }}</span>
              </label>
              <label class="radio">
                <input @change="switchDevis" v-model="choiceType" type="radio" name="radio_mobile" value="moral">
                <span class="name" style="margin-top: 4px;">{{ $t('home_page.moral_devis_label') }}</span>
              </label>
            </div>

          </div>

          <div v-show="person" class="justify-content-center row pt-3">
            <div class="card_mobile" @click="toDevisAuto()">
              <div class="justify-content-center row mt-3">
                <img   width="80" src="../../assets/img/icones/menu/cars_quote.png" alt="devis auto mobile"/>
              </div>
              <div class="justify-content-center row">
                <h2 class="justify-content-center row pt-3" style="color: #444;margin-top: -15px">
                  {{ $t('home_page.nos_assurances[1]') }}</h2>
              </div>
            </div>

            <div class="card_mobile ml-4" @click="toDevisHabitation()">
              <div class="justify-content-center row mt-3">
                <img   width="80" src="../../assets/img/icones/menu/house_quote.png" alt="devis habitation mobile"/>
              </div>
              <div class="justify-content-center row">
                <h2 class="justify-content-center row pt-3" style="color: #444;margin-top: -15px">
                  {{ $t('home_page.nos_assurances[2]') }}</h2>
              </div>
            </div>
          </div>

          <div v-show="person" class="justify-content-center row pt-3">
            <div class="card_mobile" @click="toDevisVoyage()">
              <div class="justify-content-center row mt-3">
                <img width="80" src="../../assets/img/icones/menu/travel_quote.png" alt="devis voyage mobile"/>
              </div>
              <div class="justify-content-center row">
                <h2 class="justify-content-center row pt-3" style="color: #444;margin-top: -15px">
                  {{ $t('home_page.nos_assurances[3]') }}</h2>
              </div>
            </div>

            <div class="card_mobile ml-4" @click="toDevisSante()">
              <div class="justify-content-center row mt-3">
                <img   width="80" src="../../assets/img/icones/menu/health_quote.png" alt="devis santé mobile"/>
              </div>
              <div class="justify-content-center row">
                <h2 class="justify-content-center row pt-3" style="color: #444;margin-top: -15px">
                  {{ $t('home_page.nos_assurances[4]') }}</h2>
              </div>
            </div>
          </div>

          <div v-show="person" class="justify-content-center row pt-3 pb-5">
            <div class="card_mobile" @click="toDevisVie()">
              <div class="justify-content-center row mt-3">
                <img   width="80" src="../../assets/img/icones/menu/life_quote.png" alt="devis vie mobile"/>
              </div>
              <div class="justify-content-center row">
                <h2 class="justify-content-center row pt-3" style="color: #444;margin-top: -15px">
                  {{ $t('home_page.nos_assurances[5]') }}</h2>
              </div>
            </div>
            <div class="card_mobile ml-4" @click="toDevisAssurPlus()">
              <div class="justify-content-center row mt-3">
                <img   width="80" src="../../assets/img/icones/menu/add_quote.png" alt="devis plus mobile"/>
              </div>
              <div class="justify-content-center row">
                <h2 class="justify-content-center row pt-3" style="color: #444;margin-top: -15px">
                  {{ $t('home_page.nos_assurances[6]') }}</h2>
              </div>
            </div>
          </div>

          <div v-if="moral" class="justify-content-center row pt-3">
            <div class="card_mobile" @click="toIndividuAccident()">
              <div class="justify-content-center row mt-3">
                <img   width="90" class="justify-content-center row pt-4"
                     src="../../assets/img/home/new_home/individual_accident_button.png" alt="devis individuel accident mobile"
                     style="margin-top: -25px"/>
              </div>
              <div class="justify-content-center row">
                <h2 class="justify-content-center row pt-3 text-center" style="color: #444;margin-top: -20px">
                  {{ $t('home_page.nos_assurances[12]') }}</h2>
              </div>
            </div>

            <div class="card_mobile ml-4" @click="toCaution()">
              <div class="justify-content-center row mt-3">
                <img   width="70" class="justify-content-center row pt-4"
                     src="../../assets/img/home/new_home/caution_button.png" alt="devis caution mobile" style="margin-top: -18px"/>
              </div>
              <div class="justify-content-center row">
                <h2 class="justify-content-center row text-center pt-3" style="color: #444;margin-top: -10px">
                  {{ $t('home_page.nos_assurances[10]') }}</h2>
              </div>
            </div>
          </div>

          <div v-if="moral" class="justify-content-center row pt-3">
            <div class="card_mobile" @click="toDevisMrp()">
              <div class="justify-content-center row mt-3">
                <img   width="70" src="../../assets/img/icones/menu/mrp_quote.png" alt="devis mrp mobile"/>
              </div>
              <div class="justify-content-center row">
                <h2 class="justify-content-center row text-center pt-3" style="color: #444;margin-top: -5px">MRP</h2>
              </div>
            </div>

            <div class="card_mobile ml-4" @click="toDevisTrc()">
              <div class="justify-content-center row mt-3">
                <img   width="80" src="../../assets/img/icones/menu/trc_quote.png" alt="devis trc mobile"/>
              </div>
              <div class="justify-content-center row">
                <h2 class="justify-content-center row text-center pt-3" style="color: #444;margin-top: -15px">TRC</h2>
              </div>
            </div>
          </div>

          <div v-if="moral" class="justify-content-center row pt-3">
            <div class="card_mobile" @click="toDevisAssurcare()">
              <div class="justify-content-center row mt-3">
                <img   width="70" src="../../assets/img/icones/menu/health_quote.png" alt="devis assurcare mobile"/>
                <!-- <img   width="70" class="justify-content-center row pt-4" src="../assets/img/home/new_home/habitation_button.png" alt="img" style="margin-top: -18px"/> -->
              </div>
              <div class="justify-content-center row">
                <h2 class="justify-content-center row text-center pt-3" style="color: #444;margin-top: -5px">
                  {{ $t('home_page.nos_assurances[4]') }}</h2>
              </div>
            </div>

            <div class="card_mobile ml-4" @click="toDevisFlotte">
              <div class="justify-content-center row mt-3">
                <img   width="80" src="../../assets/img/icones/menu/flotte_quote.png" alt="devis flotte mobile"/>
              </div>
              <div class="justify-content-center row">
                <h2 class="justify-content-center row text-center pt-3" style="color: #444;margin-top: -15px">
                  {{ $t('home_page.nos_assurances[11]') }}</h2>
              </div>
            </div>
          </div>

          <div class="div-wrapper">
            <img   src="../../assets/img/home/new_home/Mascot_assuraf.png" alt="kiray_assuraf mobile"/>
          </div>

        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import simplebar from 'simplebar-vue';
import 'simplebar/dist/simplebar.min.css';

export default {
  name: 'assurance_section',
  component: {
    simplebar

  },
  data: () => ({
    disabledAccessFlotte: false,
    person: true,
    moral: false,
    choiceType: 'person',  
    title: 'Assuraf',
    description: 'Le meilleur de l\'assurance en ligne au Sénégal. Faites votre devis, souscrivez et payez en ligne: vous êtes assuré ! Un service simple, une offre claire et complète, une expérience proactive et multicanale.',
    assurances: [{
      title: 'Assurance Auto/Moto',
      link: '/Auto',
      img: 'pict-ass-auto.png',
      id: 1
    },
      {
        title: 'Assurance Habitation',
        link: '/Habitation',
        img: 'pict-ass-habitation.png',
        id: 2
      },
      {
        title: 'Assurance Voyage',
        link: '/Voyage',
        img: 'pict-ass-voyage.png',
        id: 3
      },
      {
        title: 'Assurance Santé',
        link: '/Sante',
        img: 'pict-ass-sante.png',
        id: 4
      },
      {
        title: 'Assurance Vie',
        link: '#',
        img: 'pict-ass-vie.png',
        id: 5
      },
      {
        title: 'En savoir plus',
        link: '#',
        img: 'pict-ass-vie.png',
        id: 6
      }
    ],
  }),
  metaInfo() {
    return {
      title: this.title,
      meta: [{
        charset: 'utf-8'
      },
        {
          name: 'description',
          content: this.description
        }
      ]
    }
  },

  methods: {
    switchDevis() {
      if (this.choiceType === 'person') {
        this.person = true
        this.moral = false
      } else if (this.choiceType === 'moral') {
        this.person = false
        this.moral = true
      }
    },

    toDevisAuto() {
      let url = '/devis/auto'
      this.$router.push(url)
    },
    toDevisHabitation() {
      let url = '/devis/habitation'
      this.$router.push(url)
    },
    toDevisVoyage() {
      let url = '/devis/voyage'
      this.$router.push(url)
    },
    toDevisSante() {
      let url = '/devis/sante'
      this.$router.push(url)
    },
    toDevisVie() {
      let url = '/devis/vie'
      this.$router.push(url)
    },
    toDevisAssurPlus() {
      let url = '/plus'
      this.$router.push(url)
    },
    toCaution() {
      let url = "/devis/sonac/caution"
      this.$router.push(url)
    },
    toDevisMrp() {
      let url = "/devis/mrp"
      this.$router.push(url)
    },
    toDevisTrc() {
      let url = "/devis/trc"
      this.$router.push(url)
    },
    toIndividuAccident() {
      let url = "/individuel"
      this.$router.push(url)
    },

    toDevisAssurcare(){
      let url = "/devis/sante/assurcare"
      this.$router.push(url)
    },
    
    toDevisFlotte(){
      let url = "/flotte/entreprise"
      this.$router.push(url)
    }
  },

  mounted() {
  window.scrollTo(0, 0);  
  }
}
</script>

<style lang="less" scoped>

@import "../../assets/less/config";
@import "../../assets/css/button.css";

@keyframes header-animation {
  from {
    transform: translate3d(0, -100%, 0);
    opacity: 0;
  }
  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

.underline_bar {
  height: 4px;
  width: 150px;
  background: #ffa409;
}

.titre_for_desktop {
  color: #2b2b2b;
  font-size: 25px;
  font-weight: bold;
  text-align: center;
}

.margin {
  margin-left: 8%;
  margin-right: 8%;
}

.margin_mobile {
  margin-left: 5%;
  margin-right: 5%;
}

.margin-titre {
  margin-top: 48px;
  padding-bottom: 48px;
}

a, button {
  outline: none;
  cursor: pointer;
}

img {
  max-width: 100%;
}

body > .main {
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -webkit-flex-shrink: 0;
  -moz-flex-shrink: 0;
  -ms-flex-shrink: 0;
  flex-shrink: 0;
}

body > .main:after {
  content: '\00a0';
  display: block;
  height: 0;
  visibility: hidden;
}

body > .main > header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  padding: 10px;
  z-index: 0;
}

body > .main > header.fixed {
  position: fixed;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  animation: header-animation 0.35s ease-in-out;
}

body > .main > header.fixed .button-menu i, body > .main > header.fixed .button-menu i:before, body > .main > header.fixed .button-menu i:after {
  background: #505066;
}

body > .main section {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: row;
  -moz-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

@media (min-width: 960px) {
  body > .main section {
    -webkit-flex-wrap: nowrap;
    -moz-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
  }
}

@media (min-width: 1200px) {
  body > .main section {
    -webkit-flex-direction: column;
    -moz-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    display: inline-block;
    width: 33.33%;
  }

  body > .main section + section {
    margin-left: 40px;
    margin-bottom: 0;
  }
}

body > .main section > div {
  padding: 10px;
  width: 100%;
}

body > .main section > div:first-child {
  width: 100%;
}

@media (min-width: 960px) {
  body > .main section > div:first-child {
    -webkit-box-flex: 1;
    -moz-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    width: auto;
  }
}

body > .main section > div:last-child {
  min-width: 0;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -webkit-flex-basis: 1px;
  -moz-flex-basis: 1px;
  -ms-flex-basis: 1px;
  flex-basis: 1px;
  width: 1px;
}

@media (min-width: 1200px) {
  body > .main section > div:last-child {
    width: 100%;
  }
}


h1 {
  font-weight: 100;
  font-size: 58px;
}

h2 {
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
}

h3 {
  font-size: 20px;
  text-transform: uppercase;
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 40px;
}

h1, h2 {
  margin: 0 0 20px;
  color: #fff;
}

p {
  font-size: 14px;
}


.card {
  position: relative;
  margin: 2%;
  width: 140px;
  min-width: 140px;
  height: 140px;
  background: #fff;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.99);
  border-top: 1px solid rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(15px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.4);
}

.card:hover {
  cursor: pointer!important;
  background: #ffa409;
  box-shadow: 0 15px 15px rgba(0, 0, 0, 0.4);
}

.img-bx {
  position: absolute;
  top: -10px !important;
  left: -20px !important;
  width: 130%;
  height: 100%;
  border-radius: 10px;
  overflow: hidden;
  transform: translateY(30px) scale(0.5);
  transform-origin: top;
}

.img-bx img {
  position: absolute;
  top: -15px;
  //left: 10%;
  width: 100%;
  object-fit: cover;
}

.content {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding-bottom: 10px;
}

.content .detail {
  justify-content: center;
  align-items: center;
  text-align: center;
}

.content .detail h2 {
  color: #444;
  font-size: 12px;
  font-weight: bold;
  margin-left: -75px;
}


.card_mobile {
  position: relative;
  margin: 1.5%;
  width: 120px;
  min-width: 100px;
  height: 120px;
  background: #fff;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.99);
  border-top: 1px solid rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(15px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.4);
}

.card_mobile:hover {
  cursor: pointer;
  background: #ffa409;
  box-shadow: 0 15px 15px rgba(0, 0, 0, 0.4);
}




.pn_review_rating img {
  width: 20%;
}

.pn_review_profile img {
  position: absolute;
  margin: -1rem -5rem 0;
}

.pn_review_profile span {
  position: absolute;
  margin-left: 2%;
  //margin-top: 8%;
  font-weight: bold;
  color: #000000;
  font-size: 18px;
}

.pn_review_profile_mobile span {
  position: absolute;
  margin-left: 2%;
  margin-top: 4%;
  font-weight: bold;
  color: #000000;
  font-size: 18px;
}

.pn_review_profile img {
  width: 50%;
}

.pn_review_profile_mobile img {
  width: 20%;
}


@media (max-width: 575px) {
  /*---------- testimonial css start ----------*/
  .pn_reviews {
    padding: 3rem 0;
  }

  .pn_reviews h1 {
    font-size: 2rem;
    padding-bottom: 1rem !important;
  }

  .pn_review_profile img {
    position: absolute;
    margin: -1.1rem -3rem 0;
  }

  .pn_review_profile span {
    position: absolute;
    padding: 1rem;
  }

  .pn_review_rating img {
    width: auto;
  }
}

.container-mascote {
  max-width: 100%;
}

.android-app h2 {
  color: #0d4e78;
  font-weight: 100;
  font-size: 40px;
}

.text-lg-left {
  text-align: left !important;
}

.android-app ul li {
  font-size: 20px;
  font-weight: 400;
  padding-bottom: 8px;
}

.list_macotte_test {
  font-size: 20px;
  font-weight: 400;
  padding-bottom: 8px;
}

.img-fluid {
  max-width: 100%;
  height: auto;
}


.half-half-image-text {
  padding: 70px 0px;
}

.half-half-image-text h1 {
  color: #800000;
}

.half-half-image-text .content {
  height: 100%;
  display: flex;
  align-items: center;
  padding: 35px 0px;
}

.half-half-image-text .content p {
  font-size: 22px;
}

.half-half-image-text .img {
  min-height: 320px;
  height: 100%;
  border-radius: 10px;
}



.col-text {
  height: 20em;
}

.grid-flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -webkit-flex-grow: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  flex-direction: row;
  -webkit-flex-direction: row;
  -webkit-flex-wrap: wrap;
  -webkit-justify-content: space-around;
}

.col {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.col-left {
  -webkit-box-ordinal-group: -1;
  -webkit-order: -1;
  -ms-flex-order: -1;
  order: -1;
}

.col-text {
  display: flex;
  align-items: center;
  justify-content: center;
}

.Aligner-item {
  width: 70%;
  font-size: 20px
}

.col-image {
  margin-left: 7%;
  margin-top: -15% !important;
  background-size: contain;
  background-position: center center;
  //box-shadow: 9px 12px 18px rgb(0 0 0 / 5%)
  -webkit-filter: drop-shadow(5px -6px 5px #b2b1b1);
  filter: drop-shadow(5px -6px 5px #8f8e8e);
  background-image: url('../../assets/img/home/new_home/Mascot_assuraf.png');
}

@media (max-width: 640px) {
  .grid-flex {
    height: 40em;
    display: -webkit-flex;
    -webkit-flex-direction: column;
    flex-direction: column;
  }

  .col {
    order: vertical;
  }

  .col-left {
    -webkit-box-ordinal-group: 0;
    -webkit-order: 0;
    -ms-flex-order: 0;
    order: 0;
  }

  .col-text div p {
    padding: 1em;
  }

  .Aligner-item {
    width: 90%;
  }

}


.radio-inputs {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  border-radius: 0.5rem;
  background-color: #EEE;
  box-sizing: border-box;
  box-shadow: 0 0 0px 1px rgba(0, 0, 0, 0.06);
  padding: 0.7rem;
  width: 82% !important;
  font-size: 14px;
}

.radio-inputs .radio {
  flex: 1 1 auto;
  text-align: center;
}

.radio-inputs .radio input {
  display: none;
}

.radio-inputs .radio .name {
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  border: none;
  padding: 1rem 0;
  color: rgba(51, 65, 85, 1);
  transition: all .15s ease-in-out;
  font-size: 18px !important;
}

.radio-inputs .radio input:checked + .name {
  background-color: #fff;
  font-weight: 600;
  height: 40px !important;
  font-size: 18px !important;
}


.radio-inputs-mobile {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  border-radius: 0.5rem;
  background-color: #EEE;
  box-sizing: border-box;
  box-shadow: 0 0 0px 1px rgba(0, 0, 0, 0.06);
  padding: 0.7rem;
  width: 100% !important;
  font-size: 14px;
}

.radio-inputs-mobile .radio {
  flex: 1 1 auto;
  text-align: center;
}

.radio-inputs-mobile .radio input {
  display: none;
}

.radio-inputs-mobile .radio .name {
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  border: none;
  padding: 1rem 0;
  color: rgba(51, 65, 85, 1);
  transition: all .15s ease-in-out;
  font-size: 18px !important;
}

.radio-inputs-mobile .radio input:checked + .name {
  background-color: #fff;
  font-weight: 600;
  height: 40px !important;
  font-size: 18px !important;
}

























.svgIcon {
width: 20px;
transition-duration: 0.3s;
}

.svgIcon path {
fill: #000000;
}







.rotating-text {
font-size: 70px!important;
line-height: 1.2;
font-weight: bold;
}

.window {
display: inline-block;
overflow: hidden;
flex-grow: 1; /* Allows .window to grow and take up remaining space */
height: 80px!important;
vertical-align: bottom;
}

.window-inner {
display: inline-block;
animation: scroll-text 15s ease-in-out infinite;
color: #ffa409;
}
.window span {
display: block;
}

@keyframes scroll-text {
0% {
  transform: translateY(0%); /* trust */
}
26.66% {
  transform: translateY(calc(-26.66%)); /* Simplement */
}
50.33% {
  transform: translateY(calc(-50.33%)); /* Autrement */
}
75% {
  transform: translateY(calc(-75%)); /* Sereinement */
}
100% {
  transform: translateY(calc(-74.33%)); /* Pour vous (at the end) */
}
}



.nowrap {
white-space: nowrap;
}

html {
background: #292929;
color: #edebeb;
padding: 1rem;
}





@keyframes scroll-text {
0% {
  transform: translateY(0%); /* trust */
}
26.66% {
  transform: translateY(calc(-26.66%)); /* Simplement */
}
50.33% {
  transform: translateY(calc(-50.33%)); /* Autrement */
}
75% {
  transform: translateY(calc(-75%)); /* Sereinement */
}
100% {
  transform: translateY(calc(-74.33%)); /* Pour vous (at the end) */
}
}


.nowrap-mobile {
white-space: nowrap;
}

html-mobile {
background: #292929;
color: #edebeb;
padding: 1rem;
}


</style>

